// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import hrRequestStatusEntity from './entities/hr-request-status.json';
import hrRequestStatusMenu from '../pages/hr-request-status/menu.json';
import hrRequestStatusFullForm from '../pages/hr-request-status/forms/full.json';
import hrRequestStatusContextForm from '../pages/hr-request-status/forms/context.json';
import hrRequestStatusMiniForm from '../pages/hr-request-status/forms/mini.json';
import hrRequestStatusLookupForm from '../pages/hr-request-status/forms/lookup.json';
import hrRequestStatusTableView from '../pages/hr-request-status/views/table.json';
import hrRequestStatusDashboardView from '../pages/hr-request-status/views/dashboard.json';

/** Тип запису «Статус кадрової заявки» зі сторінками пакета: меню, форми та подання з pages/hr-request-status/. */
export const hrRequestStatusDefinition: IRecordTypeDefinition = {
  ...hrRequestStatusEntity,
  views: assembleViewSet({
      table: hrRequestStatusTableView,
      dashboard: hrRequestStatusDashboardView,
  }),
  form: hrRequestStatusFullForm,
  forms: { full: hrRequestStatusFullForm, context: hrRequestStatusContextForm, mini: hrRequestStatusMiniForm, lookup: hrRequestStatusLookupForm },
  menu: hrRequestStatusMenu,
} as IRecordTypeDefinition;
